import {
  RENT_HISTORY_BEGIN,
  RENT_HISTORY_SUCCESS,
  RENT_HISTORY_MODIFY_DEVICE_SUCCESS,
  RENT_HISTORY_DETACH_DEVICE_SUCCESS,
  RENT_HISTORY_ERROR,
} from 'action-creators/payway/rentHistory/constants';

const initialState = {
  rentHistory: {
    payload: {},
    loading: false,
    error: false,
  },
};

const rentHistoryReducer = (state = initialState.rentHistory, action) => {
  if (action.type === RENT_HISTORY_BEGIN) {
    return {
      ...state,
      loading: true,
    };
  }
  if (action.type === RENT_HISTORY_SUCCESS) {
    const { payload } = action;
    return {
      ...state,
      payload,
      loading: false,
    };
  }
  if (action.type === RENT_HISTORY_MODIFY_DEVICE_SUCCESS) {
    const { payload: data } = action;
    const { payload } = state;
    const info = new Array(...payload);
    info[data.page].map(p => {
      if (p.purchase_id === data.purchaseId) {
        p.device.map(d => {
          if (d.device_id === data.deviceId) {
            const dev = d;
            dev.device_name = data.deviceName;
            return dev;
          }
          return d;
        });
      }
      return p;
    });
    return {
      ...state,
      payload: info,
      loading: false,
    };
  }
  if (action.type === RENT_HISTORY_DETACH_DEVICE_SUCCESS) {
    const { payload: data } = action;
    const { payload } = state;
    const info = new Array(...payload);
    info[data.page].map(content => {
      if (content.purchase_id === data.purchase_id) {
        content.device = content.device.filter(
          d => d.device_id !== data.device_id,
        );
      }
      return content;
    });
    return {
      ...state,
      payload: info,
      loading: false,
    };
  }
  if (action.type === RENT_HISTORY_ERROR) {
    return {
      ...state,
      loading: false,
      error: {
        ...action.payload,
      },
    };
  }
  return state;
};

export default rentHistoryReducer;
